import React from "react";
import { ShieldCheck } from "lucide-react";
import SectionDocumentEditor from "./SectionDocumentEditor";
import {
  SAFETY_ACTIVITY_SECTIONS,
  SAFETY_ACTIVITY_STATUS_LABELS,
} from "@/lib/basProcess/safetyActivity";
import { generateSafetyActivityPlanWordDocument } from "@/lib/documentGenerator/basuWordGenerators";

export const SafetyActivityPlan: React.FC<{ projectId: string }> = ({ projectId }) => (
  <SectionDocumentEditor
    projectId={projectId}
    table="safety_activity_plans"
    docNumber="42"
    documentType="skyddsverksamhet"
    title="Plan för skyddsverksamhet"
    description="Hur arbetsmiljöarbetet bedrivs på plats: skyddsorganisation, möten, skyddsronder, introduktion och beredskap."
    legalRef="AFS 2023:1 · AFS 2023:3 kap. 4"
    icon={ShieldCheck}
    sections={SAFETY_ACTIVITY_SECTIONS}
    statusLabels={SAFETY_ACTIVITY_STATUS_LABELS}
    withName={false}
    onExport={(doc, projectName) => generateSafetyActivityPlanWordDocument(doc, projectName)}
    emptyText="Ingen plan för skyddsverksamhet upprättad. Skapa den med förifylld standardtext och anpassa möten, ronder och beredskap efter projektet."
  />
);

export default SafetyActivityPlan;
